import {
  createHashRouter
  } from "react-router-dom";

import App from './App';
import { ROUTES_PATH, DYNAMIC_SEGMENT } from 'Chore/Constants';
import ActivityList from './Views/ActivityList/List'
import MyActivityList from 'Views/MyActivity/ActivityList/Index';
import ActivityDetailLoader from 'RouteLoader/App/MyActivityLoader';
import MyPublishedActivitiesLoader from 'RouteLoader/App/MyPublishedActivitiesLoader';
import MyRegisteredActivitiesLoader from 'RouteLoader/App/MyPublishedActivitiesLoader';
import ActivityDetail from './Views/ActivityDetail';
import ViewMyRegisteredActivityDetail from 'Views/MyActivity/ViewMyRegisteredActivityDetail';
import ViewMyPublishedActivityDetail from 'Views/MyActivity/ViewMyPublishedActivityDetail';
import ActivityInfoForm from 'Views/ActivityFormView/ActivityInfoForm';

const router = createHashRouter([
  {
    path: ROUTES_PATH.ROOT,
    element: <App />,
    children: [
      {
        index: true,
        element: <ActivityList />,
      },
      {
        path: `${ROUTES_PATH.ACTIVITY_INFO}${DYNAMIC_SEGMENT.ID}`,
        element: <ActivityDetail/>,
        loader: ActivityDetailLoader
      },
      {
        path: ROUTES_PATH.MY_ACTIVITY,
        element: <MyActivityList />,
        loader: ActivityDetailLoader
      },
      {
        path: `${ROUTES_PATH.MY_ACTIVITY_REGISTERED_DETAIL}${DYNAMIC_SEGMENT.ID}`,
        element: <ViewMyRegisteredActivityDetail />,
        loader: MyRegisteredActivitiesLoader
      },
      {
        path: `${ROUTES_PATH.MY_ACTIVITY_PUBLISHED_DETAIL}${DYNAMIC_SEGMENT.ID}`,
        element: <ViewMyPublishedActivityDetail />,
        loader: MyPublishedActivitiesLoader
      },
      {
        path: `${ROUTES_PATH.ADD_ACTIVITY}`,
        element: <ActivityInfoForm />,
      },      {
        path: `${ROUTES_PATH.EDIT_ACTIVITY}${DYNAMIC_SEGMENT.ID}`,
        element: <ActivityInfoForm />,
        loader: ActivityDetailLoader
      }
    ],
  }
]);

export default router;
